import React from "react";
import dayjs from "dayjs";
import CustomDropdown from "../../../components/input/CustomDropdown";

const UsersListRow = ({ user, onRowClick, index, handleDropDownChange }) => {
  const getAge = (birthDate) => {
    return dayjs().diff(dayjs(birthDate), "year");
  };

  return (
    <div
      onClick={() => null}
      className="rounded-[8px] w-[99%] h-[59px] min-h-[59px] bg-[#2B2B2B] pl-[30px] flex text-white items-center cursor-pointer"
    >
      <div className={"flex"} onClick={() => onRowClick(index)}>
        <div className="w-userName">{`${user.First_name} ${user.Last_name}`}</div>
        <div className="w-userEmail">{user.Email}</div>
        <div className="w-userPhone">{user.Phone_Number}</div>
        <div className="w-userHCP flex items-center gap-2">
          {user.site?.Site_name}
        </div>
      </div>
      <div className="min-w-[124px]">
        <CustomDropdown
          variant="outlined"
          value={!!user["Enabled"]}
          onChange={(name, newValue) => {
            handleDropDownChange(index, name, newValue);
          }}
          name="Enabled"
          className="font-white"
          label=""
          data={[
            { label: "Enabled", value: true },
            { label: "Disabled", value: false },
          ]}
        />
      </div>

      <div className="ml-14 min-w-[124px]">
        <CustomDropdown
          variant="outlined"
          value={user["Role"]}
          onChange={(name, newValue) => {
            handleDropDownChange(index, name, newValue);
          }}
          name="Role"
          className="font-white"
          label=""
          data={[
            { label: "Radiologist", value: "Radiologist" },
            { label: "Admin", value: "Admin" },
          ]}
        />
      </div>
    </div>
  );
};

export default UsersListRow;
